import { Divider, TabPane } from 'semantic-ui-react';
import { useExamMaterials } from '../useExamMaterials';
import { DebouncedLoader } from 'components';
import { LinkedLrwSessions } from './LinkedLrwSessions';
import { ExamMaterialsTable } from './ExamMaterialsTable';
import { useIntParam } from 'hooks';

export const ExamMaterials = () => {
  const { linkedLrwSessions, isLoading } = useExamMaterials();
  const speakingSessionId = useIntParam('sessionId');

  if (isLoading) return <DebouncedLoader />;

  return (
    <TabPane>
      <LinkedLrwSessions linkedLrwSessions={linkedLrwSessions} />
      <Divider />
      <ExamMaterialsTable speakingSessionId={speakingSessionId} />
    </TabPane>
  );
};
